import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const DepartamentosDefault = Default

export default DepartamentosDefault;
export const DepartamentosAdicionar = Adicionar;
export const DepartamentosEditar = Editar;
